<template>
  <div class="reclamations app__page">
    <div class="reclamations__iframe-wrapper">
      <iframe id="imagepgframe" name="imagepgframe" frameborder="0" scrolling="auto" src="https://nspharm.com/r/"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OffersView',
  created() {
    this.$store.dispatch('app/setPageTitle', 'Reklamacije');
  },
};
</script>

<style lang="scss" scoped>
.reclamations {
  &__iframe-wrapper {
    height: calc(100% - 5px);
    iframe {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
